// Core
import {
  _t,
  coreData,
  createTypedSelector,
  helpers,
  hooks,
  t,
  ui,
  uitheme,
  useDispatch as baseUseDispatch,
} from '@local/finsera-core';

import * as actions from './actions';
import api from './api';
import { default as config } from './config/index';
import { RootState } from './store';
import * as ts from './typescript-definitions';

export const useSelector = createTypedSelector<RootState>();
export const useDispatch = () => baseUseDispatch<(_v: any) => any>();

export * from './libs';
export { default as PropTypes } from 'prop-types';
export { default as React } from 'react';
export { actions };
export { coreData };
export { config };
export { helpers };
export { api };
export { hooks };
export { ts };
export { uitheme };
export { ui };
export { _t, t };
